import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, Analytics as FirebaseAnalytics, setUserId } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';
import {
    getFirestore,
    collection,
    addDoc,
    serverTimestamp
} from 'firebase/firestore';
import AnalyticsEvent from './AnalyticsEvent';

const firebaseConfig = {
    // Your Firebase config object
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(app);
export const firestore = getFirestore(app);


export interface AnalyticsManagerContract {
    setUserId(userId: string): void;
    track(eventName: string, properties?: Record<string, any>): void;
}

export class AnalyticsManager implements AnalyticsManagerContract {

    private static instance: AnalyticsManager;
    private firebaseAnalytics: FirebaseAnalytics;
    private userId?: string;
    private sessionId: string;

    private constructor() {
        this.firebaseAnalytics = firebaseAnalytics;
        this.sessionId = Math.random().toString(36).substring(2, 15);
    }

    static getInstance(): AnalyticsManager {
        if (!AnalyticsManager.instance) {
            AnalyticsManager.instance = new AnalyticsManager();
        }
        return AnalyticsManager.instance;
    }

    setUserId(userId: string) {
        this.userId = userId;
        // Set user ID in Firebase Analytics
        setUserId(this.firebaseAnalytics, userId);
    }

    async track(eventName: string, properties?: Record<string, any>) {
        const event: AnalyticsEvent = {
            name: eventName,
            properties: {
                ...properties,
                sessionId: this.sessionId,
                userId: this.userId
            },
            timestamp: Date.now()
        };

        try {
            // Log to Firebase Analytics
            logEvent(this.firebaseAnalytics, eventName, event.properties);
        } catch (error) {
            console.error('Failed to track event:', error);
        }
    }

}